import Vue from 'vue'
import router from '../../router'
import axios from 'axios'
import './tabSwitchListener.js'
import './comfun.js'

// 高德地图密钥
Vue.prototype.AutonaviMapKey = '31e07f95bc3263cf57940424d19aa30e' // 高德地图密钥 1c36220393edc6bfe949d3318ce9cc9e

// 使用 location.hostname 替代 document.domain
let currentDomain = location.hostname // 私有部署自适应域名

if (currentDomain == 'localhost') {
  Vue.prototype.ApiUrl = '/api' //   后台api地址
  Vue.prototype.CurrentDomain = 'http://api.xunliao.cc' // 前端域名
  // Vue.prototype.CurrentDomain = 'https://test.xl.sz90.cn'; // 前端域名
} else {
  /* 后端api地址 */
  Vue.prototype.ApiUrl = 'https://' + currentDomain + '/api'
  /* 当前域名 */
  Vue.prototype.CurrentDomain = 'https://' + currentDomain
}

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    const title = localStorage.getItem('station_title')
    document.title = title ? title + '-' + to.meta.title : to.meta.title
  }
  // 加入浏览器缓存，防止多次请求
  if (localStorage.getItem('INSTALL') == 1) {
    return next()
  } else {
    // 不是安装页面则请求服务器检测是否已安装系统
    if (to.path.indexOf('/admin/install') == -1) {
      axios.get(Vue.prototype.ApiUrl + '/adm/check').then((res) => {
        if (res.status == 200) {
          if (res.data.status == 0) {
            return next({
              path: '/admin/install'
            })
          } else if (res.data.status == 500) {
            Vue.prototype.alertErr(res.data.msg)
          }
          localStorage.setItem('INSTALL', 1)
          return next()
        }
      })
    } else {
      next()
    }
  }
})



// WEBPACK FOOTER //
// ./src/assets/js/init.js